<script>
  import { CURRENT_COUNTRY_DETAILS } from '../stores.js';
  import { gs } from '../scripts/utils.js';
  import { LABELS, NOT_AVAILABLE, VALUES, colors } from '../config.js';
  import get from 'lodash/get'

  let title;
  let description;
  let label
  let status
  let link
  let contacts
  let color
  let location
  CURRENT_COUNTRY_DETAILS.subscribe(v => {
    title = get(v, 'label', 'unnamed')
    description = get(v, 'description', 'unnamed')
    label = gs(v, 'label')
    status = gs(v, 'status')
    link = get(v, 'link')
    contacts = get(v, 'contacts')
    location = get(v, 'location')
    color = get(VALUES, status, colors.other)
  });
</script>

<aside role="complementary">
  <header>
    <h2>{ title }</h2>
    <strong><i class="dot" style="background-color: {color}" /> { status }</strong>
  </header>
  <div class="description">
    { @html description }
  </div>
  <footer>
    <table>
      <thead>
        <tr>
          <th>{ LABELS.TABLE_CONTACT }</th>
          <th>{ LABELS.TABLE_LOCATION }</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {#if contacts.length}
            <td>
              {#each contacts as [ contact, mail ], i}
              <a href={`mailto:${mail}`} class="btn">{ contact ? contact : LABELS.TABLE_CONTACT_LABEL }</a>
              {/each}
            </td>
          {:else}
            <td>{ NOT_AVAILABLE }</td>
          {/if}
          {#if link && location}
            <td><a target="_blank" href={link}>{ location }</a></td>
          {:else}
            <td>{ NOT_AVAILABLE }</td>
          {/if}
        </tr>
      </tbody>
    </table>
  </footer>
</aside>
